import ContactCreatedEvent from '@/domains/contacts/events/ContactCreatedEvent';
import ContactDeletedEvent from '@/domains/contacts/events/ContactDeletedEvent';

const ContactEvents = {
  ContactCreated: ContactCreatedEvent,
  ContactDeleted: ContactDeletedEvent,
};

export default ContactEvents;
